import GameScreen from '../components/GameScreen';
import DrawingList from '../components/DrawingList';
import useViewportScale from '../hooks/useViewportScale';

function WaitingForJudgingScreen({ votingResponses }) {
  const px = useViewportScale();

  return (
    <GameScreen
      backgroundImage="/waiting-bg1.png"
      title="The judge is deciding..."
      contentPosition="top"
      introSound={"/This is amazing doodles.m4a"}
    >
      <DrawingList
        drawings={votingResponses}
        size={px(300)}
        style={{
          position: 'relative',
          zIndex: 1,
          marginTop: '2rem',
        }}
      />
    </GameScreen>
  );
}

export default WaitingForJudgingScreen;
